// test2426
(2426 && 0);
